/**
 * Shared color mapping for gov order statuses. Used by GovOrders,
 * GovApprovals, GovOrderDetail, and any other place we render a status pill.
 */
export const STATUS_STYLE = {
  pending_approval: 'bg-amber-100 text-amber-700 border-amber-200',
  sent_back:        'bg-rose-100 text-rose-700 border-rose-200',
  approved:         'bg-blue-100 text-blue-700 border-blue-200',       // legacy
  uske_processing:  'bg-sky-100 text-sky-800 border-sky-200',
  processing:       'bg-purple-100 text-purple-700 border-purple-200',
  in_transit:       'bg-indigo-100 text-indigo-800 border-indigo-200',
  shipped:          'bg-indigo-100 text-indigo-700 border-indigo-200', // legacy alias
  delivered:        'bg-emerald-100 text-emerald-800 border-emerald-200',
  finalized:        'bg-teal-100 text-teal-800 border-teal-200',
  completed:        'bg-slate-200 text-slate-700 border-slate-300',
  rejected:         'bg-red-100 text-red-700 border-red-200',
  cancelled:        'bg-slate-200 text-slate-700 border-slate-300',
};

export const STATUS_LABEL = {
  pending_approval: 'Pending Approval',
  sent_back:        'Sent Back',
  approved:         'Approved',
  uske_processing:  'USKE Processing',
  processing:       'Processing',
  in_transit:       'In Transit',
  shipped:          'Shipped',
  delivered:        'Delivered',
  finalized:        'Finalized',
  completed:        'Completed',
  rejected:         'Rejected',
  cancelled:        'Cancelled',
};

export const statusBadge = (s) => STATUS_STYLE[s] || 'bg-slate-100 text-slate-600 border-slate-200';
export const statusLabel = (s) => STATUS_LABEL[s] || (s || '').replace(/_/g, ' ');

// Statuses currently used in the gov ordering flow — used by the Orders
// filter dropdown to match the real live state machine.
export const GOV_STATUS_FILTERS = [
  'pending_approval',
  'sent_back',
  'approved',
  'uske_processing',
  'in_transit',
  'delivered',
  'finalized',
];
